import React from "react";
import { CardsContainer } from "./Homecards.style";

const Homecards: React.FC<{
  image: string;
  title: string;
  description: string;
}> = ({ image, title, description }) => {
  return (
    <CardsContainer>
      <img src={image} alt={title} className="card-image" />
      <p className="card-text">
        <span className="card-title">{title}: </span>
        <span className="card-description">{description}</span>
      </p>
    </CardsContainer>
  );
};

export default Homecards;
